import type { DropDownResult } from '@myosh/odin-components';
import i18next from '../../../i18n';

export type IntervalType = DropDownResult & Record<string, unknown>;
export const timeIntervals: Array<IntervalType> = [
  { text: i18next.t('days'), value: 'DAYS' },
  { text: i18next.t('weeks'), value: 'WEEKS', displayWeek: true },
  { text: i18next.t('months'), value: 'MONTHS', displayMonth: true, displayDayOfMonth: true },
  { text: i18next.t('years'), value: 'YEARS', displayMonth: true, displayDayOfMonth: true },
];

export const dayValues: Array<IntervalType> = [
  { text: i18next.t('weekdays-monday'), value: 'MONDAY' },
  { text: i18next.t('weekdays-tuesday'), value: 'TUESDAY' },
  { text: i18next.t('weekdays-wednesday'), value: 'WEDNESDAY' },
  { text: i18next.t('weekdays-thursday'), value: 'THURSDAY' },
  { text: i18next.t('weekdays-friday'), value: 'FRIDAY' },
  { text: i18next.t('weekdays-saturday'), value: 'SATURDAY' },
  { text: i18next.t('weekdays-sunday'), value: 'SUNDAY' },
];

export const monthValues: Array<IntervalType> = [
  { text: i18next.t('months-january'), value: 'JANUARY' },
  { text: i18next.t('months-february'), value: 'FEBRUARY' },
  { text: i18next.t('months-march'), value: 'MARCH' },
  { text: i18next.t('months-april'), value: 'APRIL' },
  { text: i18next.t('months-may'), value: 'MAY' },
  { text: i18next.t('months-june'), value: 'JUNE' },
  { text: i18next.t('months-july'), value: 'JULY' },
  { text: i18next.t('months-august'), value: 'AUGUST' },
  { text: i18next.t('months-september'), value: 'SEPTEMBER' },
  { text: i18next.t('months-october'), value: 'OCTOBER' },
  { text: i18next.t('months-november'), value: 'NOVEMBER' },
  { text: i18next.t('months-december'), value: 'DECEMBER' },
];

export function getAllTimezones() {
  return Intl.supportedValuesOf('timeZone').map((timeZone) => {
    const offset = getTimeZoneOffset(timeZone);
    return { text: `${timeZone} (${offset})`, value: timeZone };
  });
}

export const getTimeZoneOffset = (timeZone: string) => {
  return new Intl.DateTimeFormat('en', { timeZone: timeZone, timeZoneName: 'shortOffset' })
    .formatToParts()
    .find((part) => part.type === 'timeZoneName')?.value;
};
